// Wetroom floor planner. The former enquiry form has been removed from the homepage.
(() => {
  if (window.wetroomRefreshLoaded) return;
  window.wetroomRefreshLoaded = true;
  function init(scope) {
    scope.querySelectorAll('[data-wr-home]').forEach((root) => {
      if (root.dataset.wrReady) return;
      const length = root.querySelector('[data-wr-length]');
      const width = root.querySelector('[data-wr-width]');
      const output = root.querySelector('[data-wr-result]');
      if (!length || !width || !output) return;
      root.dataset.wrReady = 'true';
      const choices = root.querySelectorAll('[data-wr-floor]');
      let floor = root.querySelector('[data-wr-floor][aria-pressed="true"]')?.dataset.wrFloor || 'Timber floor';
      const refresh = () => {
        output.textContent = `${floor} — ${length.value} × ${width.value} mm`;
      };
      choices.forEach((button) => button.addEventListener('click', () => {
        choices.forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        floor = button.dataset.wrFloor;
        refresh();
      }));
      length.addEventListener('change', refresh);
      width.addEventListener('change', refresh);
      refresh();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
